import styled from "styled-components";

import * as Dropdown from "ds/Dropdown";
import Search, { Icon, Close } from "ds/Search";
import { Search as SearchPrimitive } from "ds/Search/Search.styles";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  justify-content: space-between;
  form {
    margin: 0;
  }

  .info-button {
    > button {
      width: auto;
      padding: 0 !important;
      border: none;
      .icon {
        margin: 0 0 0 16px;
      }
      .chevron {
        width: auto;
      }
      > .chevron {
        margin: 0 -4px 0 12px;
      }
      &:hover,
      &.open {
        .icon rect {
          fill: var(--icon-color-primary-600-fill, var(--color-primary-600));
        }
        svg {
          transform: none;
        }
      }
    }
  }

  .integration-filter-window {
    width: 300px;
    white-space: nowrap;
    .checkbox-field {
      margin-bottom: 0;
    }
    h6 {
      font-size: 14px;
      color: var(--section-ebony-light-color, var(--ebony-light));
      font-weight: bold;
      line-height: 24px;
    }
    .checkbox-field.checked label {
      color: var(--section-color-primary-600-color, var(--color-primary-600));
    }
  }
`;

export const DropdownHeader = styled.div`
  display: flex;
  justify-content: space-between;

  & + div[role="separator"] {
    background-color: ${"var(--section-color-primary-100-border-color,var(--color-primary-100))"};
  }
`;
export const DropdownTrigger = styled(Dropdown.Trigger)`
  color: var(--button-slate-color, var(--slate));
  &:hover,
  &:focus,
  &[data-state="open"] {
    background-color: transparent;
    color: var(--button-color-primary-600-color, var(--color-primary-600));
  }
`;

export const SearchInput = styled(Search)`
  :has(${SearchPrimitive}:focus) {
    ${Icon} {
      fill: var(--mode-vector-neutral-strong);
    }
  }

  ${SearchPrimitive} {
    padding-left: 2px;
    &::placeholder {
      font-size: 14px;
      line-height: 24px;
      color: var(--mode-text-neutral-default-weak);
    }

    &:focus {
      &::placeholder {
        color: var(--mode-text-neutral-weakest);
      }
    }
  }

  ${Icon} {
    fill: var(--mode-vector-neutral-default);
  }

  ${Close} {
    display: none;
  }

  border-bottom: none;
`;
